'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BaseTileHeader = renderWithRef('BaseTileHeader', null, (a, o)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-base-tile-header'
        ],
        props: a,
        children: a.children
    }));

export { BaseTileHeader };
